import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-dark border-bottom" style={{ borderColor: 'black' }}>
      <div className="container">
        <Link className="navbar-brand" to="/" style={{ fontFamily: "'Fredoka One', cursive" }}>
          SAUCISTATS
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/') ? 'active' : ''}`}
                to="/"
              >
                <i className="bi bi-house-fill"></i> Accueil
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/hall-of-fame') ? 'active' : ''}`}
                to="/hall-of-fame"
              >
                <i className="bi bi-trophy"></i> Hall of Fame
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/tournois') ? 'active' : ''}`}
                to="/tournois"
              >
                <i className="bi bi-calendar-event"></i> Tournois
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/smasheurs') ? 'active' : ''}`}
                to="/smasheurs"
              >
                <i className="bi bi-people"></i> Joueurs
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/trophees') ? 'active' : ''}`}
                to="/trophees"
              >
                <i className="bi bi-award"></i> Trophées
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link link-light ${isActive('/anecdotes') ? 'active' : ''}`}
                to="/anecdotes"
              >
                <i className="bi bi-body-text"></i> Anecdotes
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;